/**
 * Fetch and cache feature flags from /feature-flags.
 *
 * Module-level singletons (cachedFlags, fetchPromise) ensure the API is called
 * exactly once regardless of how many components mount this hook concurrently.
 * All subsequent mounts reuse the in-memory cache — no re-fetches for the
 * lifetime of the page. On error, defaults to { subscriptions_visible: false, coffee_preferences_enabled: false }.
 */
import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
let cachedFlags = null;   // populated after first successful fetch
let fetchPromise = null;  // deduplicates concurrent first-mount fetches

/**
 * Returns the current feature flags object. Fetches once per page lifetime.
 * @returns {{ subscriptions_visible: boolean }}
 */
export function useFeatureFlags() {
  const [flags, setFlags] = useState(cachedFlags || { subscriptions_visible: false, coffee_preferences_enabled: false });

  useEffect(() => {
    if (cachedFlags) {
      setFlags(cachedFlags);
      return;
    }
    if (!fetchPromise) {
      fetchPromise = axios.get(`${API}/api/feature-flags`)
        .then(res => {
          cachedFlags = res.data;
          return res.data;
        })
        .catch(() => ({ subscriptions_visible: false, coffee_preferences_enabled: false }));
    }
    fetchPromise.then(data => {
      cachedFlags = data;
      setFlags(data);
    });
  }, []);

  return flags;
}
